<template>
    <div class="QuestionnaireList padding-20 bgc box-shadow">
        <div class="filters">
            <div class="add">
                <el-button type="primary" @click="handleAdd">创建问卷</el-button>
            </div>
            <div class="search">
                <el-input v-model="param.name" placeholder="请输入关键字" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="examcode" label="问卷名称" min-width="180px" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img class="img" v-lazy="scope.row.coverurl?scope.row.coverurl:bgQuesHeader" :alt="scope.row.name"
                                 preview="bbOrderList">
                            <div class="text-ellipses"><div class="text">{{scope.row.name}}</div></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="fillovertime" label="完成时间" class-name="tc" label-class-name="tc">
                    <template slot-scope="scope">{{scope.row.fillovertime?scope.row.fillovertime: '--'}}</template>
                </el-table-column>
                <el-table-column prop="fillcustomercount" label="填写人数" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="kmcnames" label="关联内容" class-name="tc" label-class-name="tc">
                    <template slot-scope="scope"><div class="text-ellipses"><div class="text">{{scope.row.kmcnames}}</div></div></template>
                </el-table-column>
                <el-table-column prop="viewcount" label="浏览量" width="120px" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="statusname" label="状态" width="120px" class-name="tc" label-class-name="tc">
                    <template slot-scope="scope"><div  :class="status(scope.row.status)">{{scope.row.statusname}}</div></template>
                </el-table-column>
                <el-table-column label="操作" width="240px" label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                            <span class="separator-btn">
                                <el-button @click.stop="handleView(scope.row)" type="text" size="small" v-if="[10,100].indexOf(scope.row.status)>-1">查看</el-button>
                                <el-button @click.stop="handleEdit(scope.row)" type="text" size="small" v-if="[0,30].indexOf(scope.row.status)>-1">编辑</el-button>
                            </span>
                            <span class="separator-btn" v-if="[0,10,30].indexOf(scope.row.status)>-1">
                                <el-button @click.stop="handleEnd(scope.row)" type="text" size="small" v-if="[10].indexOf(scope.row.status)>-1">结束</el-button>
                                <el-button @click.stop="handleRelease(scope.row)" type="text" size="small" v-if="[0,30].indexOf(scope.row.status)>-1">发布</el-button>
                            </span>
                            <span class="separator-btn" v-if="[0,10,30].indexOf(scope.row.status)>-1">
                                <el-button @click.stop="handleSheet(scope.row)" type="text" size="small">答卷</el-button>
                            </span>
                            <span class="separator-btn" v-if="[0,10].indexOf(scope.row.status)>-1">
                                <el-button @click.stop="handleShare(scope.row)" type="text" size="small">分享</el-button>
                            </span>
                            <span class="separator-btn">
                                <el-dropdown>
                                    <span class="el-dropdown-link">
                                        <el-button type="text" size="small">更多</el-button>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item @click.native="handleCopy(scope.row)">复制</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleExport(scope.row)">导出</el-dropdown-item>
                                       <el-dropdown-item @click.native="handleDel(scope.row)" v-if="[0,10,30].indexOf(scope.row.status)>-1">删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="_getList" :current-page.sync="page.page"
            :page-size="page.pageSize" :pager-count="11" layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
        <quesSheetDialog ref="quesSheetDialog"></quesSheetDialog>
        <invateLinkDialog ref="invateLinkDialog"></invateLinkDialog>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getAllCommonFormList, updateCommonStatus, exportCommonUserFormList} from 'api/operateToolApi'
import {_setClass, questionnaire} from 'api/enumCode'
import {dateFormat} from 'common/js/tools'
import QuesSheetDialog from 'views/operateTool/questionnaire/components/quesSheetDialog.vue'
import InvateLinkDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateLinkDialog.vue'
export default {
    name: 'QuestionnaireList',
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            param: {
                name: ''
            },
            bgQuesHeader: require('@/common/images/quesnaire/bg_ques_header.png'),
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleAdd() {
            this.$router.push({ name: 'QuestionnaireEdit'})
        },
        handleEdit(row) {
            this.$router.push({ name: 'QuestionnaireEdit', query: {innerid: row.innerid}})
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleView(row) {
            this.$router.push({ name: 'QuestionnaireEdit', query: {innerid: row.innerid, isView: 1}})
        },
        handleDel(row) {
            this.$confirm('确认删除该问卷？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    innerid: row.innerid,
                    status: 100,
                }
                this._editStatus(obj)
            }).catch(() => {})
        },
        handleSheet(row) {
            this.$refs.quesSheetDialog.openDialog(row)
        },
        handleCopy(row) {
            this.$router.push({ name: 'QuestionnaireEdit', query: {innerid: row.innerid, isCopy: 1}})
        },
        handleShare(row) {
            this.$refs.invateLinkDialog.openDialog(row.shareurl, '分享链接')
        },
        handleEnd(row) {
            this.$confirm('结束问卷调查用户无法填写，确认结束吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    innerid: row.innerid,
                    status: 30,
                }
                this._editStatus(obj)
            }).catch(() => {})
        },
        handleRelease(row) {
            this.$confirm('发布成功后用户可参与问卷调查？', '提示', {
                confirmButtonText: '立即发布',
                cancelButtonText: '暂不发布'
            }).then(() => {
                let obj = {
                    innerid: row.innerid,
                    status: 10,
                }
                this._editStatus(obj)
            }).catch(() => {})
        },
        handleExport(row) {
            this.setLoading(true)
            exportCommonUserFormList({
                data: {innerid: row.innerid},
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '答卷' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editStatus(param) {
            this.setLoading(true)
            updateCommonStatus({
                data: param,
                success: () => {
                    this.setLoading(false)
                    this.$message.success('修改成功')
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getAllCommonFormList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        status () {
            return function(value) {
                return _setClass(value, questionnaire.status)
            }
        }
    },
    components: {
        QuesSheetDialog, InvateLinkDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .QuestionnaireList {
        .imageText{
            display: flex;
            .img{
                width: 106px;
                height: 60px;
                min-width: 106px;
                border-radius: 2px;
                margin-right: 10px;
            }
        }
    }
</style>
